import { render, staticRenderFns } from "./fixed.vue?vue&type=template&id=2dac8f43&scoped=true&"
import script from "./fixed.vue?vue&type=script&lang=js&"
export * from "./fixed.vue?vue&type=script&lang=js&"
import style0 from "./fixed.vue?vue&type=style&index=0&id=2dac8f43&prod&scoped=true&lang=scss&"
import style1 from "./fixed.vue?vue&type=style&index=1&id=2dac8f43&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dac8f43",
  null
  
)

export default component.exports